import { render, staticRenderFns } from "./upload-reques-dialog.vue?vue&type=template&id=564cdbf7&scoped=true&"
import script from "./upload-reques-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-reques-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upload-reques-dialog.vue?vue&type=style&index=0&id=564cdbf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564cdbf7",
  null
  
)

export default component.exports